<script lang="ts">
  import type { IPlacement } from "src/ts/Interfaces";
  import Slider from "./Slider.svelte";

  export let placement: IPlacement;
</script>

<div class="stack">
  <Slider
    labelText="Move image horizontally (%)"
    min={0}
    max={100}
    step={1}
    value={placement.xPostionInPercentage}
    on:change={(e) => {
      placement.xPostionInPercentage = e.detail;
    }}
  />
  <Slider
    labelText="Move image vertically (%)"
    min={0}
    max={100}
    step={1}
    value={placement.yPostionInPercentage}
    on:change={(e) => {
      placement.yPostionInPercentage = e.detail;
    }}
  />
</div>
